import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Récidive d'alcool au volant : conséquences et emprisonnement?"
            description="Vous avez de nouveau été arrêté pour conduite avec les facultés affaiblies par l'alcool ? Nous vous expliquons tout ce qu'il faut savoir sur les conséquences d'une récidive !"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour Récidive d’alcool au volant">
            <p>
                Si vous êtes intercepté pour une deuxième fois pour alcool au
                volant, voici les conséquences:
            </p>
            <ul>
                <li>Suspension immédiate du permis de conduire,</li>
                <li>Saisie de votre véhicule,</li>
                <li>Peine d’emprisonnement,</li>
                <li>Casier judiciaire, et</li>
                <li>Obligation d’avoir un antidémarreur.</li>
            </ul>
            <p>
                <strong>
                    <Img
                        fluid={data.img0.childImageSharp.fluid}
                        title="Conséquences de l’alcool au volant!"
                        alt=""
                    />
                </strong>
            </p>
            <p>
                En effet, les conséquences sont beaucoup plus importantes que
                pour{' '}
                <Link to="https://avocatsalcoolauvolant.ca/premiere-infraction-alcool-volant/">
                    une première infraction
                </Link>
                . Il est donc important de faire appel à un avocat spécialisé en
                droit criminel dès que possible.{' '}
            </p>
            <p>
                <strong>
                    Voyez toutes les conséquences d’une deuxième (ou troisième)
                    condamnation pour alcool au volant!
                </strong>
            </p>
            <h2>
                <strong>
                    Quelles sont les conséquences d'une récidive pour conduite
                    avec les facultés affaiblies par l’alcool au Québec?
                </strong>
            </h2>
            <p>
                Si vous en êtes à votre deuxième infraction d’alcool au volant
                dans un intervalle de 10 ans, vous aurez, en plus de la
                suspension de votre permis:
            </p>
            <ul>
                <li>Une saisie de votre véhicule,</li>
                <li>Une révocation de votre permis,</li>
                <li>Une peine d’emprisonnement obligatoire, et</li>
                <li>Des restrictions de conduite.</li>
            </ul>
            <p>
                La loi prévoit des mesures immédiates dès l'arrestation ainsi
                que des conséquences à long terme plus lourdes après une
                deuxième condamnation
            </p>
            <h4>
                <strong>
                    1) Suspension immédiate du permis de conduire et
                    interdiction de conduire
                </strong>
            </h4>
            <p>
                L’une des premières conséquences est la suspension immédiate du
                permis de conduire <strong>pour une durée de 90 jours.</strong>
            </p>
            <p>
                En plus de la suspension immédiate de 90 jours lors de
                l’arrestation, la personne reconnue coupable sera interdite de
                conduire pour une durée minimale de 2 ans.
            </p>
            <h4>
                <strong>2) Saisie du véhicule</strong>
            </h4>
            <p>
                Le véhicule du contrevenant sera immédiatement saisi pour une
                période de 90 jours.
            </p>
            <h4>
                <strong>3) Révocation du permis après condamnation</strong>
            </h4>
            <p>
                Une révocation du permis de conduire est imposée lorsque le
                conducteur est reconnu coupable. Celle-ci peut durer de 3 à 5
                ans, voire plus, selon la gravité de la situation et la décision
                du juge.
            </p>
            <h4>
                <strong>4) Peine d’emprisonnement obligatoire</strong>
            </h4>
            <p>
                Une autre sanction inévitable en cas de récidive est une peine
                d’emprisonnement. Pour une deuxième infraction,{' '}
                <strong>une peine minimale de 30 jours</strong> de prison est
                imposée.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Participation obligatoire au programme Alcofrein!"
                    alt=""
                />
            </p>
            <p>
                Cette durée peut être prolongée jusqu'à 10 ans, selon les
                circonstances spécifiques de l’infraction et l’appréciation du
                tribunal.
            </p>
            <h4>
                <strong>5) Restrictions sur les véhicules</strong>
            </h4>
            <p>
                Une 2e condamnation peut entraîner des restrictions concernant
                l’utilisation du véhicule. Vous pourriez avoir l'interdiction
                d’immatriculer, d’acquérir, de louer ou de mettre en circulation
                un véhicule.
            </p>
            <h4>
                <strong>6) Dispositif antidémarrage à vie</strong>
            </h4>
            <p>
                Le tribunal peut ordonner l’installation d’un dispositif
                antidémarrage à vie dans le véhicule du conducteur. Après 10
                ans, il est possible de demander son retrait.
            </p>
            <h4>
                <strong>
                    7) Participation à des programmes de sensibilisation
                </strong>
            </h4>
            <p>
                Le conducteur peut être condamné à suivre le Programme
                d’évaluation et de réduction du risque de conduite avec les
                facultés affaiblies.
            </p>
            <h4>
                <strong>
                    8) Amendes imposées en fonction du taux d’alcool
                </strong>
            </h4>
            <p>
                Une amende est imposée au contrevenant. Le montant varie en
                fonction de la concentration d'alcool dans le sang au moment de
                l'arrestation :
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Concentration d’alcool</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Contravention minimale</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 80 et 119 mg par 100 ml de sang</p>
                    </td>
                    <td>
                        <p>1 000 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 120 et 159 mg par 100 ml de sang</p>
                    </td>
                    <td>
                        <p>1 500 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            160 mg et plus (ou refus de souffle dans
                            l’alcootest)
                        </p>
                    </td>
                    <td>
                        <p>2 000 $</p>
                    </td>
                </tr>
            </table>
            <h4>
                <strong>9) Inscription au casier judiciaire</strong>
            </h4>
            <p>
                La deuxième condamnation pour conduite avec les facultés
                affaiblies est inscrite au casier judiciaire du contrevenant.
            </p>
            <h3>
                <strong>
                    Comment récupérer son permis de conduire après une récidive
                    d’alcool au volant ?
                </strong>
            </h3>
            <p>
                Après une deuxième infraction pour alcool au volant dans un
                délai de moins de 10 ans, la possibilité de récupérer un permis
                de conduire devient plus complexe.
            </p>
            <p>
                Il n’est pas possible de récupérer un permis de conduire
                standard ; il faut obtenir un permis de conduire assorti de
                certaines conditions
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Peine d’emprisonnement en cas de récidive pour alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Voici les étapes à suivre pour obtenir ce permis de conduire :
            </p>
            <table>
                <tr>
                    <td>
                        <p>Étapes</p>
                    </td>
                    <td>
                        <p>Explication</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Réception de la lettre de la SAAQ</p>
                    </td>
                    <td>
                        <p>
                            Dès la réception du jugement du tribunal, la SAAQ
                            enverra au contrevenant une lettre confirmant sa
                            culpabilité, la révocation de son permis ainsi que
                            la durée de la sanction.
                        </p>
                        <p>
                            Cette lettre précisera la possibilité d’obtenir un
                            permis restreint, si applicable, et mentionne
                            l’obligation de conduire un véhicule équipé d’un
                            antidémarreur éthylométrique à vie.
                        </p>
                        <p>
                            Elle indiquera l’interdiction d’acquérir, de louer
                            ou d’immatriculer un véhicule à son nom pendant la
                            période de sanction.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Admissibilité à la condition</p>
                    </td>
                    <td>
                        <p>
                            Un mois avant la fin de la sanction, la SAAQ enverra
                            au contrevenant une nouvelle lettre pour l'informer
                            qu'il est désormais admissible à un permis assorti
                            de la condition X.
                        </p>
                        <p>
                            Pour conduire, il devra installer un antidémarreur
                            éthylométrique dans son véhicule.
                        </p>
                        <p>
                            Cette condition restera en place pendant une période
                            de 10 ans, après quoi le contrevenant pourra faire
                            une demande pour en obtenir la levée, mais cette
                            démarche devra être entreprise par lui-même devant
                            la Cour du Québec.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Location et installation de l'antidémarreur
                            éthylométrique
                        </p>
                    </td>
                    <td>
                        <p>
                            Si vous avez la condition X, il faudra louer et
                            installer à vos frais un antidémarreur
                            éthylométrique, conformément aux exigences de la
                            SAAQ.
                        </p>
                        <p>
                            En cas de non-respect de cette obligation, des
                            sanctions sévères pourront être imposées:
                        </p>
                        <ul>
                            <li>
                                Saisie immédiate du véhicule pour une durée
                                entre 30 et 90 jours;
                            </li>
                            <li>Contravention entre 1 500 $ et 3 000 $;</li>
                            <li>Suspension prolongée du permis.</li>
                        </ul>
                        <p>
                            L'installation d'un antidémarreur éthylométrique
                            comporte des frais d'installation de 50 $, ainsi que
                            des frais mensuels de location d'environ 60 $. À la
                            fin de la période de sanction, le retrait de
                            l'appareil et la fermeture du dossier sont sans
                            frais..
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Payer les frais</p>
                    </td>
                    <td>
                        <p>
                            Une fois toutes les conditions remplies et après la
                            période de sanction, il faudra acquitter des frais
                            d'obtention de son nouveau permis, qui varient entre
                            420 $ et 560 $.
                        </p>
                    </td>
                </tr>
            </table>
            <h3>
                <strong>
                    Comment éviter les conséquences d'une récidive grâce à
                    l'aide d'un avocat spécialisé en droit criminel?
                </strong>
            </h3>
            <p>
                Pour éviter les conséquences d'une récidive pour conduite avec
                les facultés affaiblies, il est fortement recommandé de{' '}
                <strong>
                    consulter un avocat spécialisé en droit criminel.{' '}
                </strong>
            </p>
            <p>
                L'une des stratégies les plus efficaces consiste à négocier avec
                la poursuite afin d'éviter l'enregistrement d'un avis de
                récidive.
            </p>
            <p>
                L’avocat peut négocier avec le procureur de la couronne pour
                parvenir à un accord favorable. Dans ce cas, le conducteur
                reconnaît sa culpabilité, mais l’avis de récidive, qui entraîne
                automatiquement des sanctions sévères telles qu’une peine
                d’emprisonnement obligatoire et d’autres restrictions, ne sera
                pas déposé.
            </p>
            <h2>
                <strong>
                    Vous êtes accusé de conduite avec les facultés affaiblies
                    par l’alcool pour une deuxième fois? Consultez un avocat
                    spécialisé!
                </strong>
            </h2>
            <p>
                Avoir un avocat à vos côtés vous offre une réelle opportunité de
                réduire les conséquences graves d'une récidive, comme la peine
                d’emprisonnement obligatoire. Il saura analyser votre dossier en
                détail et mettre à profit son expertise pour négocier avec la
                poursuite.
            </p>

            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Avocat pour récidive d'alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                N'attendez pas pour contacter un avocat spécialisé en droit
                criminel, car ses services peuvent véritablement influencer
                l’issue de votre dossier. Plus tôt vous agirez, plus vous
                augmentez vos chances d’obtenir un résultat favorable et de
                réduire les conséquences d’une deuxième infraction.
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire rapide et gratuit, vous pourrez
                    facilement trouver un avocat spécialisé en droit criminel !
                </strong>
            </p>
            <p>
                <strong>
                    Après avoir soumis votre demande, nous vous mettrons
                    rapidement en relation avec un avocat criminaliste près de
                    chez vous, sans aucun engagement de votre part.
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "recidive-alcool-volant/consequence-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "recidive-alcool-volant/participation-obligatoire-programme-alcofrein.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "recidive-alcool-volant/prison-obligatoire-recidive-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "recidive-alcool-volant/recuperer-permis-recidive-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "recidive-alcool-volant/avocat-recidive-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
